import React, {useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import {useTable} from 'react-table';
import * as actions from '../../_redux/paymentsActions';
import * as columnFormatters from './column-formatters';
import * as commonColumnFormatters from '../../../_common/column-formatters';
import {useAutomatedPaymentsUIContext} from '../AutomatedPaymentsUIContext';
import useInfiniteScrollControl
  from '../../../_common/components/_custom-hooks/useInfiniteScrollControl';
import {useDispatch} from "react-redux";
import SortingColumnHeader from './SortingColumnHeader';
import CommonGrid from "../../../_common/components/CommonGrid/CommonGrid";

export function AutomatedPaymentsTable() {
  const intl = useIntl();
  const dispatch = useDispatch();

  const [tableRows, setTableRows] = useState([]);

  const columns = useMemo(() => [
    {
      accessor: 'agent',
      Header:
        <SortingColumnHeader
          header={'automatedPayments-column-agent'}
          defaultMessage={'Agent'}
          fieldName={'agentID'}
        />
    },
    {
      accessor: 'idNumber',
      Header:
        <SortingColumnHeader
          header={'automatedPayments-column-idNumber'}
          defaultMessage={'ID'}
          fieldName={'idNumber'}
        />
    },
    {
      accessor: 'paymentRequestDate',
      Header:
        <SortingColumnHeader
          header={'automatedPayments-column-paymentRequestDate'}
          defaultMessage={'Payment request date'}
          fieldName={'paymentRequestDate'}
        />
    },
    {
      accessor: 'lastStatusUpdateDate',
      Header:
        <SortingColumnHeader
          header={'automatedPayments-column-lastStatusUpdateDate'}
          defaultMessage={'Status update date'}
          fieldName={'lastStatusUpdateDate'}
        />
    },
    {
      accessor: 'amount',
      Header:
        <SortingColumnHeader
          header={'automatedPayments-column-amount'}
          defaultMessage={'Amount'}
          fieldName={'totalAmount'}
        />
    },
    {
      accessor: 'status',
      Header:
        <SortingColumnHeader
          header={'automatedPayments-column-status'}
          defaultMessage={'Status'}
          fieldName={'statusID'}
        />
    },
    {
      accessor: 'resend',
      Header: intl.formatMessage({
        id: 'automatedPayments-column-resend', defaultMessage: 'Resend'
      })
    },
    {
      accessor: 'updateStatus',
      Header: intl.formatMessage({
        id: 'automatedPayments-column-updateStatus', defaultMessage: 'Update status'
      })
    },
    {
      accessor: 'downloadPaymentConfirm',
      Header: intl.formatMessage({
        id: 'automatedPayments-column-downloadPaymentConfirm', defaultMessage: 'Download payment confirm'
      })
    },
    {
      accessor: 'setBirthDate',
      Header: intl.formatMessage({
        id: 'automatedPayments-column-setBirthDate', defaultMessage: 'Set birth date'
      })
    },
    {
      accessor: 'updateAmount',
      Header: intl.formatMessage({
        id: 'automatedPayments-column-updateAmount', defaultMessage: 'Update amount'
      })
    },
  ], []);
  const data = useMemo(() => [
    ...tableRows.map((item) => {
      return {
        agent: [
          commonColumnFormatters.BoldLTRColumnFormatter(item.agentID),
          commonColumnFormatters.FullNameColumnFormatter(item)
        ],
        idNumber: commonColumnFormatters.BoldColumnFormatter(item.idNumber),
        paymentRequestDate: commonColumnFormatters.DateColumnFormatter(item.paymentRequestDate),
        lastStatusUpdateDate: commonColumnFormatters.DateColumnFormatter(item.lastStatusUpdateDate),
        amount: commonColumnFormatters.BoldColumnFormatter(item.totalAmount),
        status: [
          commonColumnFormatters.BoldColumnFormatter(item.statusText),
          commonColumnFormatters.LimitContentWidthNormalColumnFormatter(item.rejectReasonText)
        ],
        resend: columnFormatters.ResendColumnFormatter(item, intl, dispatch),
        updateStatus: columnFormatters.UpdateStatusColumnFormatter(item, intl, dispatch),
        downloadPaymentConfirm: columnFormatters.DownloadPaymentConfirmColumnFormatter(item, intl, dispatch),
        setBirthDate: columnFormatters.SetBirthDateColumnFormatter(item, intl, dispatch),
        updateAmount: columnFormatters.UpdateAmountColumnFormatter(item, intl, dispatch),
      };
    })
  ], [tableRows]);

  const infiniteScrollProps = useInfiniteScrollControl({
    currentStateStoreId: 'payments',
    UIContext: useAutomatedPaymentsUIContext(),
    getNewEntities: actions.getPayments,
    getNextEntities: actions.getNextPayments,
    onEntitiesChange: entities => {
      setTableRows(entities);
    },
    dataLength: tableRows.length,
    scrollableTarget: 'scrollContainer',
    scrollThreshold: 0.9,
    loader: (
      <div className={'spinner-container'}>
        <span className={'spinner spinner-md spinner-primary'}/>
      </div>
    ),
    style: {
      overflow: 'inherit'
    },
  });

  return (
    <CommonGrid
      infiniteScrollProps={infiniteScrollProps}
      tableProps={useTable({columns, data})}
      customTableStyles={'payments-table'}
    />
  );
}
